import { render, staticRenderFns } from "./ViewUserListModal.vue?vue&type=template&id=928d0a8e&"
import script from "./ViewUserListModal.vue?vue&type=script&lang=js&"
export * from "./ViewUserListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports